/** @format */

import React from 'react'

import { Select, Input } from 'antd'

import Options from './options.json'

export default function RejectForm(props) {
	return (
		<>
			<p style={{ color: '#e66557' }}>Recuerde que la observación será enviada al paciente.</p>
			<Select
				showSearch
				placeholder='Motivo de rechazo'
				labelInValue
				style={{ width: '100%' }}
				onChange={(item) => props.handleSelectChange(item)}
				filterOption={(input, option) =>
					option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
				}>
				{Options.invalidReasons.map((option) => (
					<Select.Option key={option.type} value={option.type}>
						{option.type}
					</Select.Option>
				))}
			</Select>
			<br />
			<br />
			{props.reason.label === 'Otro' && (
				<Input.TextArea placeholder='Motivo de rechazo' onChange={props.handleTextAreaChange} />
			)}
		</>
	)
}
